module.exports = __webpack_public_path__ + "static/media/vector (1).61d75b6e.svg";